ACC.deliverymode = {

  bindAll: function() {
    this.bindEditDeliveryMethodButton();
  },

  bindEditDeliveryMethodButton: function() {
    $('div.checkout_summary_flow_c .change_mode_button').on('click', function() {
      ACC.omniture.bindTrackConversion('interaction', 'delivery_method');
      $.ajax({
        url: $('.ph-getDeliveryModesUrl').text(),
        type: 'GET',
        dataType: 'json',
        success: function(data) {
          // Fill the available delivery addresses and select button
          $('#delivery_modes_dl').html($('#deliveryModesTemplate').tmpl({
            showDeliveryCostForCountry: JSON.parse($('.ph-showDeliveryCostForCountry').text()),
            deliveryModes: data
          }));
          $('#delivery_modes_button').html($('#deliveryModeButton').tmpl({
            deliveryModes: data
          }));

          // Show the delivery modes popup
          $.colorbox({
            inline: true,
            href: '#popup_checkout_delivery_modes',
            height: false,
            maxWidth: '90%',
            close: '<button type=\'button\' id=\'ph-cboxClose\' class=\'ph-favclose\'><span class=\'ph-icon-cross ph-favcross\'></span></button>',
            overlayClose: false
          });
          ACC.deliverymode.bindUseThisDeliveryMode();
          ACC.deliverymode.bindShipmenttoggle();
        },
        error: function(xht, textStatus, ex) {
          if (textStatus === 'error' || textStatus === 'parsererror' || ex.status === 302) {
            window.location = '/login/checkout';
          } else {
            /* eslint-disable  no-alert */
            alert('Failed to get delivery modes. Error details [' + xht + ', ' + textStatus + ', ' + ex + ']');
            /* eslint-enable  no-alert */
          }
        }

      });

      return false;
    });
  },
  bindUseThisDeliveryMode: function() {
    $('#use_this_delivery_method').click(function() {
      var objdata = {};

      objdata.modeCode = $('input:radio[name=delivery]:checked').val();
      objdata.deliveryStatus = '';
      objdata.generalinstructions = $('#generalinstructions').val();

      if ($('.radio1').prop('checked') === true) {
        objdata.deliveryStatus = 'true';
      } else {
        objdata.deliveryStatus = 'false';
      }

      if (objdata.modeCode) {
        $.ajax({
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json; charset=utf-8'
          },
          url: $('.ph-setDeliveryModeUrl').text(),
          type: 'POST',
          dataType: 'json',
          data: JSON.stringify(objdata),
          beforeSend: function() {
            $.colorbox.toggleLoadingOverlay();
          },
          success: function(data) {
            if (data === null) {
              /* eslint-disable  no-alert */
              alert('Failed to set delivery mode');
              /* eslint-enable  no-alert */
            } else {
              ACC.refresh.refreshCartItems(data);
              ACC.refresh.refreshPage(data);
              parent.$.colorbox.close();
            }
          },
          error: function(xht, textStatus, ex) {
            /* eslint-disable  no-alert */
            alert('Failed to get delivery modes. Error details [' + xht + ', ' + textStatus + ', ' + ex + ']');
            /* eslint-enable  no-alert */
          },
          complete: function() {
            $.colorbox.toggleLoadingOverlay();
          }
        });
      }

      return false;
    });
    $('input[name="completeDelivery"]').on('click', function() {
      ACC.deliverymode.bindShipmenttoggle();
    });
  },
  bindShipmenttoggle: function() {
    var deliverySelected = $('input[name="completeDelivery"]:checked').parents('.ph-compdelivery');

    if (deliverySelected.length > 0) {
      $('.ph-completeshipment').show();
    } else {
      $('.ph-completeshipment').hide();
    }
  },
  refreshDeliveryMethodSection: function(data) {
    $('#checkout_summary_deliverymode_div').replaceWith($('#deliveryModeSummaryTemplate').tmpl(data));
    ACC.deliverymode.bindEditDeliveryMethodButton();
    setTimeout(function() {
      ACC.deliverymode.bindShipmenttoggle();
    }, 5000);
  }
};
$(document).ready(function() {
  ACC.deliverymode.bindAll();
});

